import React from 'react';
import clsx from 'clsx';

import styles from './Pic.module.scss';
import { isBrandLabelCmpnt } from '../api/brandUtil';

export default function Pic({ brand, icon, distance }) {
	const isBrandLabel = isBrandLabelCmpnt(brand);

	return (
		<div className={clsx(styles.root, isBrandLabel ? styles.label : null)}>
			{brand ? brand : icon}
			<small
				className={clsx(styles.distance, 'distance')}
				value={distance}
			>
				{isNaN(distance) ? distance : getFormattedDistance(distance)}
			</small>
		</div>
	);
}

function getFormattedDistance(distance) {
	let distanceHTML = '';

	if (distance / 1000 < 1) {
		distanceHTML += parseInt(distance, 10) + ' m';
	} else {
		let temp = distance / 1000;

		if (temp > 100) {
			temp = Math.round(temp);
			distanceHTML += formatNumber(temp) + ' km';
		} else {
			distance = temp.toString();
			distanceHTML +=
				'' + distance.substring(0, distance.indexOf('.') + 2) + ' km';
			distanceHTML = distanceHTML.replace('.', ',');
		}
	}

	return distanceHTML;
}

function formatNumber(nStr) {
	var x, x1, x2;

	nStr += '';
	x = nStr.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';

	var rgx = /(\d+)(\d{3})/;

	while (rgx.test(x1)) {
		// x1 = x1.replace(rgx, '$1' + '.' + '$2');
		x1 = x1.replace(rgx, '$1.$2');
	}

	return x1 + x2;
}
